import verde from '../common/verde.js'
import loadScript from '../common/loadScript.js'
import {
  VALID_USER,
  INVALID_USER,
  VALIDATING_USER,
  USER_VALIDITY_UNKNOWN,
} from '../common/constants/User.js'
import {prevalidatedCompanySelector} from './company.js'
import {formSelector, getState, setForm} from '../store.js'
import {showGlobalError} from '../ordoro/GlobalErrorMessage.js'

const USER_VALIDITY = 'user_validity'

export function setUserValidity(userValidity) {
  setForm(USER_VALIDITY, userValidity)
}

export function userValiditySelector(state) {
  return formSelector(state, {formName: USER_VALIDITY}) || USER_VALIDITY_UNKNOWN
}

export function isValidatingUserSelector(state) {
  return userValiditySelector(state) === VALIDATING_USER
}

export function isUserValidSelector(state) {
  return userValiditySelector(state) === VALID_USER
}

export function isUserInvalidSelector(state) {
  return userValiditySelector(state) === INVALID_USER
}

export function onReCaptchaReady() {
  return new Promise((resolve, reject) => {
    window.grecaptcha.ready((err) => {
      if (err) {
        reject(err)
      } else {
        resolve()
      }
    })
  })
}

export function getPublicKey() {
  return window.ORDORO_BOOTSTRAP.env.RECAPTCHA_PUBLIC_KEY
}

export function getToken(recaptchaPublicKey, action = 'pappy') {
  return window.grecaptcha.execute(recaptchaPublicKey, {action})
}

export async function loadRecaptcha(action) {
  if (window.THIS_IS_A_TEST_ENV) {
    return 'test_token'
  }

  const recaptchaPublicKey = getPublicKey()

  await loadScript(
    `https://www.google.com/recaptcha/api.js?render=${recaptchaPublicKey}`,
  )

  await onReCaptchaReady()

  const token = await getToken(recaptchaPublicKey, action)

  return token
}

export async function verifyUser() {
  const userValidity = userValiditySelector(getState())

  if (userValidity === VALID_USER) {
    return
  }

  const prevalidatedCompany = prevalidatedCompanySelector(getState())

  if (prevalidatedCompany) {
    setUserValidity(VALID_USER)

    return
  }

  try {
    setUserValidity(VALIDATING_USER)

    const token = await loadRecaptcha()

    const {json} = await verde.post('/recaptcha/verify', {token})

    setUserValidity(
      json.success && json.score > 0.5 ? VALID_USER : INVALID_USER,
    )
  } catch (err) {
    showGlobalError(
      {
        summary: 'Error validating user.',
        details: err.message || err.error_message,
      },
      err,
    )

    setUserValidity(USER_VALIDITY_UNKNOWN)
  }
}
